module.exports = global.EventSource;



/*****************
 ** WEBPACK FOOTER
 ** ./~/sockjs-client/lib/transport/browser/eventsource.js
 ** module id = 569
 ** module chunks = 9
 **/